import React from 'react';
import { Input, iInput } from '@lomadee/design-system';
import { PatternFormat } from 'react-number-format';

interface MaskedInputI extends iInput {
  mask?: string;
  maskChar?: string | null;
  alwaysShowMask?: boolean;
}

const MaskedInput: React.FC<MaskedInputI> = ({
  mask,
  maskChar,
  alwaysShowMask,
  size,
  maxLength,
  value = '',
  ...props
}) => {
  const replaced = mask?.replace(/[a-zA-Z0-9]/g, '#');

  if (!mask) return <Input value={value} size={size} {...props} />;

  return (
    // @ts-ignore
    <PatternFormat
      customInput={Input}
      format={replaced}
      value={value as string}
      allowEmptyFormatting={alwaysShowMask}
      {...props}
    />
  );
};

export default MaskedInput;
